const familyOf = match => match.family === "arc" || match.competitionType === "nra_arc"
  ? "arc" : match.family || match.competitionType;
const keyOf = match => `${familyOf(match)}:${match.matchId}`;
export const sideMatchLabel = match => Number.isInteger(match.sideMatchOrder) && match.sideMatchOrder > 0
  ? `Side match ${match.sideMatchOrder}` : "Side match";

// Group only loaded, filtered records. A missing parent must never hide a child
// or invent a result outside the search. A later page can supply the parent.
export function groupRelatedMatches(matches) {
  const records = new Map(matches.map(match => [keyOf(match), match]));
  const groups = new Map();
  for (const match of records.values()) {
    const family = familyOf(match);
    const parentKey = `${family}:${match.parentMatchId}`;
    const parent = records.get(parentKey);
    const isSide = ["arc", "bullseye"].includes(family) && typeof match.parentMatchId === "string"
      && match.parentMatchId && match.parentMatchId !== match.matchId && !parent?.parentMatchId;
    const key = isSide ? parentKey : keyOf(match);
    if (!groups.has(key)) groups.set(key, { key, family, parentMatchId: isSide ? match.parentMatchId : match.matchId, mainMatch: null, sideMatches: [] });
    if (isSide) groups.get(key).sideMatches.push(match);
    else groups.get(key).mainMatch = match;
  }
  for (const group of groups.values()) group.sideMatches.sort((a, b) => {
    const order = match => Number.isInteger(match.sideMatchOrder) && match.sideMatchOrder > 0 ? match.sideMatchOrder : Infinity;
    return order(a) - order(b) || String(a.matchName || "").localeCompare(String(b.matchName || "")) || a.matchId.localeCompare(b.matchId);
  });
  return [...groups.values()];
}
